<app-employee-list [showInactive]="true"></app-employee-list>
